import React, { useCallback, useMemo, useState } from 'react';

import { Divider, Flex, Image, Input, Link, Spacer } from '@chakra-ui/react';
import Text from '@molecules/Text';
import Button from '@molecules/Button';
import Card from '@molecules/Card';
import BEIcon from '@molecules/BEIcon';
import { useNavigate } from 'react-router';
import { API } from '../../config';

const exampleProperties = {
  'https://hotels.dev-ga.cloudbeds-dev.com': [
    { name: 'up Delaware', id: '557016', code: 'jCvklW' },
    { name: 'Plastic Metal', id: '557027', code: 'ULiw1K' },
  ],
};

const Main: React.FC = () => {
  const [url, setURL] = useState<string>('');
  const navigate = useNavigate();
  const baseEndpoint = useMemo(() => {
    const loc = new URL(API);
    return loc.origin;
  }, []);

  const examples = useMemo(() => {
    const loc = new URL(API);
    const properties = exampleProperties[loc.origin] || [];
    return properties;
  }, []);

  const onClickOpenProperty = useCallback(() => {
    const loc = new URL(url);
    navigate(loc.pathname);
  }, [navigate, url]);

  return (
    <Flex justifyContent={'center'} p={'20px'} w="100%">
      <Flex
        w="100%"
        maxW="640px"
        flexDir={'column'}
        alignItems={'center'}
        gap="20px"
        textAlign={'center'}
      >
        <Image src="./cb-logo.svg" alt="logo" />
        <Card gap={'8px'}>
          <Text type="h2">BookingEngine v3</Text>
          <Flex gap="16px">
            <Input
              value={url}
              onChange={(e) => setURL(e.target.value)}
              placeholder="Booking Engine url..."
              _placeholder={{ opacity: 0.6 }}
            ></Input>
            <Button onClick={onClickOpenProperty}>Open</Button>
          </Flex>
          <Flex mt="8px" gap="8px">
            <BEIcon name="info-circle" color="neutral" />
            <Text size="sm" color="neutral">
              Enter the url of the Cloudbeds's booking engine you want to try on
              the new v3 system. It should be on the current environment{' '}
              <a target="_blank" href={baseEndpoint} rel="noreferrer">
                {baseEndpoint}
              </a>
            </Text>
          </Flex>
        </Card>

        {examples.length > 0 && (
          <Card>
            <Text type="h2">Example properties</Text>
            {examples.map((property) => (
              <Flex key={property.id}>
                <Link href={`/reservas/${property.code}`}>
                  <Text>{property.name}</Text>
                </Link>
                <Spacer />
                <Link href={`${baseEndpoint}/connect/${property.id}`}>
                  <BEIcon name="magnify" />
                </Link>
                <Link href={`/reservas/${property.code}`}>
                  <BEIcon name="eye" />
                </Link>
              </Flex>
            ))}
          </Card>
        )}
      </Flex>
    </Flex>
  );
};

export default Main;
